/*
  this is the place to calculate the new state, based on the action (type and payload) provided

  eg:

  export const addItem = item => ({type: ADD_ITEM, payload: {id: val, arg1: val, arg2: val} })
*/

import { combineReducers } from 'redux'
import { createForms } from 'react-redux-form';

import accountsReducer from './accountsReducer'
import authReducer from './authReducer'
import entriesReducer from './entriesReducer'
import reportsReducer from './reportsReducer'
// import feedsReducer from './feedsReducer'
import preferencesReducer from './preferencesReducer'
import scriptsReducer from './scriptsReducer'
import usersReducer from './usersReducer'

import {
  initialLogin,
  initialNewProject,
  initialNewFeed,
  initialNewColumns,
  initialRemoveColumn,
  initialSearchFilters,
  initialUser
} from './formsReducer'

const rootReducer = combineReducers({
  account: accountsReducer,
  auth: authReducer,
  entry: entriesReducer,
  // feed: feedsReducer,
  report: reportsReducer,
  preference: preferencesReducer,
  script: scriptsReducer,
  user: usersReducer,
  ...createForms({
    login: initialLogin,
    newProject: initialNewProject,
    newFeed: initialNewFeed,
    newColumns: initialNewColumns,
    removeColumn: initialRemoveColumn,
    setFilters: initialSearchFilters,
    userForm: initialUser
  })
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/js/reducers/index.js